import { CLIENT_META_HEADERS as H } from "../constants/clientMetaHeaders";

const CLIENT_ID_KEY = "comtech_web_client_id";
const IP_CACHE_KEY = "comtech_web_client_ip";
const APP_VERSION = "1.0.0";
let cachedIpAddress = null;

const getOrCreateClientId = () => {
  try {
    let clientId = localStorage.getItem(CLIENT_ID_KEY);
    if (!clientId) {
      if (typeof crypto !== "undefined" && crypto.randomUUID) {
        clientId = crypto.randomUUID();
      } else {
        clientId = "web-" + Date.now() + "-" + Math.random().toString(36).slice(2);
      }
      localStorage.setItem(CLIENT_ID_KEY, clientId);
    }
    return clientId;
  } catch (_error) {
    return "web-" + Date.now();
  }
};

const parseBrowserOs = () => {
  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "web";

  let browser = "Browser";
  if (/Edg\//.test(ua)) browser = "Edge";
  else if (/Chrome\//.test(ua)) browser = "Chrome";
  else if (/Firefox\//.test(ua)) browser = "Firefox";
  else if (/Safari\//.test(ua)) browser = "Safari";

  let os = platform;
  if (/Windows/i.test(ua)) os = "Windows";
  else if (/Mac OS X/i.test(ua)) os = "macOS";
  else if (/Android/i.test(ua)) os = "Android";
  else if (/iPhone|iPad|iPod/i.test(ua)) os = "iOS";
  else if (/Linux/i.test(ua)) os = "Linux";

  return {
    browser,
    os,
    label: browser + " on " + os,
  };
};

const readStoredIp = () => {
  try {
    return localStorage.getItem(IP_CACHE_KEY) || null;
  } catch (_error) {
    return null;
  }
};

const storeIp = (ip) => {
  cachedIpAddress = ip;
  try {
    localStorage.setItem(IP_CACHE_KEY, ip);
  } catch (_error) {
    // ignore
  }
};

export function initClientIpCache() {
  if (cachedIpAddress) {
    return Promise.resolve(cachedIpAddress);
  }

  const storedIp = readStoredIp();
  if (storedIp) {
    cachedIpAddress = storedIp;
    return Promise.resolve(cachedIpAddress);
  }

  let timeoutId;
  const controller =
    typeof AbortController !== "undefined" ? new AbortController() : null;

  if (controller) {
    timeoutId = window.setTimeout(() => {
      controller.abort();
    }, 5000);
  }

  return fetch("https://api.ipify.org?format=json", {
    signal: controller ? controller.signal : undefined,
    cache: "no-store",
  })
    .then((response) => {
      if (timeoutId) window.clearTimeout(timeoutId);
      if (!response.ok) throw new Error("IP lookup failed: " + response.status);
      return response.json();
    })
    .then((data) => {
      if (data && data.ip) storeIp(String(data.ip));
      return cachedIpAddress;
    })
    .catch(() => {
      if (timeoutId) window.clearTimeout(timeoutId);
      return cachedIpAddress;
    });
}

export function getCachedClientIp() {
  return cachedIpAddress || readStoredIp();
}

/** Headers attached to marketing-site API requests (same shape as admin). */
export function getClientApiHeaders() {
  const parsed = parseBrowserOs();
  const ipaddress = getCachedClientIp();

  const headers = {
    [H.appVersion]: APP_VERSION,
    [H.appBuildNumber]: APP_VERSION,
    [H.deviceType]: "web",
    [H.deviceModel]: parsed.browser,
    [H.systemVersion]: parsed.os,
    [H.bundleId]: window.location.origin || "comtech-marketing-web",
    [H.deviceId]: getOrCreateClientId(),
    [H.deviceOs]: parsed.label,
  };

  if (ipaddress) {
    headers[H.ipAddress] = ipaddress;
  }

  return headers;
}
